import { HelmetDexteel } from "@dexteel/mesf-core";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { Donut } from "../../models/Donut";
import { getDonuts } from "../../repositories/DonutRepository";
import { TableDonut } from "./components/TableDonut";

type useDonutsProps = {
	partId?: number;
	onError?: (error: Error) => void;
};

export const useDonuts = ({ partId, onError }: useDonutsProps) => {
	return useQuery<Donut[], Error>({
		queryKey: ["donuts", partId],
		meta: { realtime: ["M2.GetDonuts"] },
		queryFn: ({ signal }) => getDonuts({ partId }, signal),
		onError: onError,
	});
};

export const DonutPage = () => {
	const { partId } = useParams();

	return (
		<>
			<HelmetDexteel title="Donuts" />
			<TableDonut partId={partId} />
		</>
	);
};
